export default __webpack_public_path__ + "static/media/reception-merchandises-icon.a3914c89.png";